import { FC, useMemo } from "react";

import { getCourseStationById, IStationWrapperCourseProps } from "@ryde/shared";

import { StationCourse } from "./station.course";

export const StationWrapperCourse: FC<IStationWrapperCourseProps> = ({
  stationId,
  courseDto,
  stationIndex,
  isLastStation,
  isFirstStation,
}) => {
  const station = useMemo(() => {
    return getCourseStationById(courseDto, stationId);
  }, [courseDto, stationId]);
  return (
    station && (
      <StationCourse
        station={station}
        courseDto={courseDto}
        isLastStation={isLastStation}
        isFirstStation={isFirstStation}
        stationIndex={stationIndex}
      />
    )
  );
};
